import {TextField} from "@mui/material";
import styles from "./styles/Styles.module.css";
import _ from "lodash";

export default function BasicMultilineTextField({input, label, id, name, handleChange, placeholder, rowsCount= 2, sx, meta: { touched, error }}) {
    const hasError = touched && !_.isEmpty(error);

    return(
        <div>
            <TextField className={ hasError ? styles.multilineTextFieldError : styles.multilineTextField }
                       InputProps={{ classes: { root: styles.multilineTextField } }}
                       FormHelperTextProps={{ className: styles.helperText }}
                       id={id}
                       sx={sx}
                       name={name}
                       label={label}
                       variant="outlined"
                       onChange={handleChange}
                       placeholder={placeholder}
                       {...input}
                       error={ hasError }
                       helperText={ hasError ? error : undefined }
                       multiline
                       rows={rowsCount} />
        </div>
    )
}
